<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import medicionAusentismoAPI from "@/services/standards/medicionAusentismo/medicionAusentismoAPI";

export default {
    page: {
        title: "Medición del ausentismo por causa médica",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: {
        Layout,
        Style,
        PageHeader,
    },
    data() {
        return {
            title: "3.3.6 Medición del ausentismo por causa médica",
            items: [
                {
                    text: "Estandares",
                    href: "/forms/estandares",
                },
                {
                    text: "Medición",
                    active: true,
                },
            ],
            years: [],
            medicion: {
                annual_goal: null,
                monthly_goal: null,
                annual_period: 1,
                year: null,
                people_know_result: null,
                responsible_measurement: null,
                companies_id: null,
            },
        }
    },
    methods: {
        getRole(name, roles) {
            // Get the user role
            let role = this.$store.state.auth.info.role
                ? this.$store.state.auth.info.role
                : null;
            // If the user is logged
            if (role) {
                // If the roles array is not empty
                if (roles) {
                    // Know if the role indicated is in the roles array
                    role = roles.includes(role) ? true : false;
                } // Close if the roles arrays is not empty
                // If the roles arrays is empty
                else {
                    // Know if the user role is in the roles indicated
                    role =
                        role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
                } // Close if the roles arrays is empty
                // Get the user permissions
                const permissions = this.$store.state.auth.info.permissions;
                // Know if the user has the permission indicated
                const enabled = permissions.find(
                    (permission) => permission.name === name
                );
                // If the user has the permission indicated and the user role is in the roles indicated
                return enabled && role ? true : false;
            } // Close if the user is logged
            // If the user is not logged
            else {
                return false;
            } // Close else the user is not logged
        },

        getList() {
            medicionAusentismoAPI
                .getShowF(this.$route.params.id)
                .then((response) => {
                    this.medicion = {
                        annual_goal: response.data.annual_goal,
                        monthly_goal: response.data.monthly_goal,
                        annual_period: response.data.annual_period,
                        year: response.data.year,
                        people_know_result: response.data.people_know_result,
                        responsible_measurement: response.data.responsible_measurement,
                        companies_id: response.data.companies_id,
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        rangeYear() {
            const max = 2040;
            const min = 2019;
            for (let i = min; i <= max; i++) {
                this.years.push(i);
            }
            return this.years
        },

        goBack() {
            this.$router.go(-1);
        },
    },
    mounted() {
        this.rangeYear();
        this.getList();
    },
}
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row animated animatedFadeInUp fadeInUp">
            <div class="col-md-12 m-0 p-0">
                <div class="card">
                    <div class="card-body">

                        <div class="row">
                            <div class="col-12 text-right m-b-0">
                                <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                                    <i class="fas fa-arrow-left"></i>
                                </div>
                                <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                            </div>
                        </div>
                        <hr />

                        <form class="form-group" @submit.prevent="save">
                            <div class="table-responsive px-4 mt-2" v-if="getRole('Consultar')">
                                <table
                                    class="table-sm pt-2 table border-bottom divide-y divide-gray-200 table-bordered rounded">
                                    <thead class="bg-primary text-light">
                                        <tr>
                                            <th class="text-center align-middle" colspan="4">
                                                Ficha tecnica del indicador
                                            </th>
                                        </tr>
                                        <tr>
                                            <th class="text-center align-middle">Nombre indicador</th>
                                            <th class="text-center align-middle" colspan="3">
                                                Medición del ausentismo por causa médica
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        <tr>
                                            <td class="bg-primary text-light text-center align-middle">
                                                <b>Formula</b>
                                            </td>
                                            <td class="text-center align-middle" colspan="3">
                                                (Número de días de ausencia por incapacidad laboral y
                                                común / Número de días de trabajo programados) *100
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="bg-primary text-light text-center align-middle">
                                                <b>Intrerpretación del indicador</b>
                                            </td>
                                            <td class="text-center align-middle" colspan="3">
                                                En el mes X se perdió x% de días de trabajo programados
                                                por incapacidad médica
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="bg-primary text-light text-center align-middle">
                                                <b> Meta</b>
                                            </td>
                                            <td class="text-center align-middle">
                                                <b-form-input disabled class="col-md-4" type="text" id="date_exam"
                                                    v-model="medicion.monthly_goal" maxlength="3">
                                                </b-form-input>
                                            </td>

                                            <td class="text-center align-middle">
                                                <b-form-input disabled class="col-md-4" type="text" id="date_exam"
                                                    v-model="medicion.annual_goal" maxlength="3">
                                                </b-form-input>
                                            </td>
                                            <td class="text-center align-middle">
                                                <select disabled class="col-md-8 form-control" v-model="medicion.year">
                                                    <b-form-select-option v-for="item in years" :value="item">
                                                        {{ item }}
                                                    </b-form-select-option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="bg-primary text-light text-center align-middle">
                                                <b> Periocidad</b>
                                            </td>
                                            <td class="text-center align-middle" colspan="1">
                                                Mensual
                                            </td>

                                            <td class="text-center align-middle" colspan="1">
                                                Anual
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="bg-primary text-light text-center align-middle">
                                                <b>Fuente de la información</b>
                                            </td>
                                            <td class="align-middle" colspan="3">
                                                <p>Incapacidades por eventos de tipo común</p>
                                                <p>Incapacidades por eventos de tipo laboral</p>
                                                <p>Número de días laborados en el mes</p>
                                                <p>Número de trabajadores en el mes</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="bg-primary text-light text-center align-middle">
                                                <b> Personas que deben conocer el resultado</b>
                                            </td>
                                            <td class="text-center align-middle" colspan="3">
                                                <b-form-input disabled type="text" id="date_exam" maxlength="200"
                                                    v-model="medicion.people_know_result">
                                                </b-form-input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="bg-primary text-light text-center align-middle">
                                                <b> Responsable de la medición </b>
                                            </td>
                                            <td class="text-center align-middle" colspan="3">
                                                <b-form-input disabled type="text" id="date_exam" maxlength="200"
                                                    v-model="medicion.responsible_measurement">
                                                </b-form-input>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>